import React, { useEffect, useState } from "react";
// import { createUserWithEmailAndPassword} from "firebase/auth";
// import { auth, db } from "../firebase";
// import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";

const RegisterPage = () => {
  const { userRole } = useAuth()
  const [Form, setForm] = useState({
    email:"",
    password:""
  });
  
const handleChange = (e) => {
  const {name,value} = e.target
  setForm({
    ...Form,
    [name]:value,
  })
}

  useEffect(() => {
    if (userRole !== "manager") {
      navigate('/dashboard')
    }
  }, [userRole])


  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);


  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    // const displayName = e.target[0].value;
    

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/v1/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ "email": Form.email, "password": Form.password }),
      });

      if (response.ok) {
        // const { user } = await response.json();
        console.log('employee created')
        setLoading(false)
      } else {
        // setErrorMsg("Error signing in")
        console.log("Error")
      }
    } catch (err) {
      console.log(err);
      setErr(true);
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen">
      <div className="w-full bg-white flex items-center justify-center flex-col">
        <div className="formWrapper md:w-[60%] w-[80%]">
          <span className="text-black font-bold sm:text-3xl text-base">Register A New Employee</span>

          <form onSubmit={handleSubmit} className="flex flex-col gap-y-3 mt-3 sm:mt-6">
            <input
              required
              type="email"
              placeholder="email"
              className="px-[10px] h-[40px] bg-slate-100 rounded w-full"
              name="email"
              onChange={handleChange}
              value={Form.email}
            />
            <input
              required
              type="password"
              placeholder="password"
              className="px-[10px] h-[40px] bg-slate-100 rounded w-full"
              name="password"
              onChange={handleChange}
              value={Form.password}
            />

            <button disabled={loading} className="py-[8px] bg-[#007FFF] text-white mb-[20px]">
              Register
            </button>
            {loading && "Registering..."}
            {err && <span>Something went wrong</span>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
